// @flow
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import {
    ConnectionProvider,
    CcnProvider,
    CompaniesProvider,
    ChatBotProvider,
    FavoritesProvider,
    ReviewsProvider,
    HistoryProvider,
    FilterProvider,
} from "providers";
import { ConnectionConsumer } from "providers";
import { LocalStorage } from "services";
import { PublicRoutes, PrivateRoutes } from "routes";
import { Theme, Header, Footer } from "components";
import Provider from "Provider";
import "./App.scss";

type Props = {};

type State = {
    header: boolean,
    footer: boolean,
};
/**
 * App
 * @author Tomasz tpr@deltacode.fr
 * @memberof App
 * @extends {React.Component}
 * @description App Component
 */
class App extends Component<Props, State> {
    /**
     * @constructor
     */

    constructor(props: Props) {
        super(props);
        this.state = {
            header: false,
            footer: false,
        };
    }

    async componentDidMount() {
        /**
         * @instance
         * @async
         * @memberof Components.WithRouterHeader
         * @method componentDidMount
         * @return { Void }
         */

        const header = await LocalStorage.getItem("header");
        const footer = await LocalStorage.getItem("footer");

        await this.setState({
            header: header === "true" ? true : false,
            footer: footer === "true" ? true : false,
        });
    }

    render() {
        /**
         * @instance
         * @method render
         * @memberof App.App
         * @return { String } JSX
         */
        return (
            <ConnectionProvider>
                <ConnectionConsumer>
                    {(props) => (
                        <Router>
                            {props.authenticated ? (
                                <Provider
                                    providers={[
                                        CcnProvider,
                                        CompaniesProvider,
                                        ChatBotProvider,
                                        FavoritesProvider,
                                        ReviewsProvider,
                                        HistoryProvider,
                                        FilterProvider
                                    ]}
                                >
                                    <Theme />
                                    {props.header || this.state.header ? (
                                        <Header />
                                    ) : null}

                                    <PrivateRoutes
                                        {...{
                                            ...props,
                                        }}
                                    />

                                    {props.footer || this.state.footer ? (
                                        <Footer />
                                    ) : null}
                                </Provider>
                            ) : (
                                <PublicRoutes />
                            )}
                        </Router>
                    )}
                </ConnectionConsumer>
            </ConnectionProvider>
        );
    }
}

export default App;
